module.exports = __webpack_public_path__ + "static/media/imageRight.23d8c60d.png";